import { ApiCall } from '../../../../submodules/web-shared/services/http-service/types/ApiCall';
import { publicHttpService } from '../../shared/services/public-http-service';
import { PublicCompanyData } from './types/PublicCompanyData';

export const getPublicCompanyData: ApiCall<null, PublicCompanyData> = async ({ abortSignal }) => {
  const { data } = await publicHttpService.get(
    '/api/v3/public/company',
    null,
    abortSignal,
  );
  return data;
};